import { DIVISIONS } from '@tracsis/library/src/constants/BusinessUnits';
import { GLOBAL_NAVIGATION } from '@tracsis/library/src/constants/GlobalNavigation';

export const LINKS = {
	ABOUT_TRACSIS: '/about-tracsis/',
	HISTORY: '/about-tracsis/our-history/',
	SUSTAINABILITY: '/about-tracsis/sustainability/',
	ACQUISITIONS: '/about-tracsis/acquisitions/',
	CARBON_REDUCTION: '/carbon-reduction-plan/',
	CAREERS: '/careers/',
	ETHICAL_EMPLOYER: '/careers/ethical-employer/',
	GENDER_PAY: '/careers/gender-pay/',
	LIFE_AT_TRACSIS: '/careers/life-at-tracsis/',
	EMPOWERING_OUR_TEAM: '/careers/empowering-our-team/',
	JOIN_THE_RIGHT_TEAM: '/careers/join-the-right-team/',
	VACANCIES: 'https://tracsis.careers.hibob.com/jobs',
	INVESTORS: '/investors/',
	INVESTMENT_CASE: '/investors/investment-case/',
	BOARD_DIRECTORS: '/investors/board-of-directors/',
	SHARE_PRICE: '/investors/share-price-information/',
	DOCUMENTS: '/investors/documents/',
	SIGNIFICANT_SHAREHOLDERS: '/investors/significant-shareholders/',
	ADVISORS: '/investors/advisors/',
	REPORTS_PRESENTATIONS: '/investors/reports-and-presentations/',
	CORPORATE_GOVERNANCE: '/investors/corporate-governance/',
	AIM_26: '/investors/aim-rule-26/',
	INVESTORS_RAIL_TECH:
		'/investors/investors-day/rail-technology-product-demonstration-for-investors/',
	CASE_STUDIES: '/case-studies/',
	REGULATORY_NEWS: '/investors/regulatory-news/',
	RESOURCES: '/resources/',
	NEWS: '/news/',
	PRESS: '/press-and-media/',
	MEDIA_ASSETS: '/media-assets/',
	CONTACT: '/contact/',
	TERMS: '/terms/',
	PRVIACY: '/privacy-policy/',
	COOKIES: '/cookie-policy/',
	RAIL_TECH: DIVISIONS.RAIL.to,
	DACE: DIVISIONS.DACE.to,
	FINANCIAL_REPORTS: '/investors/financial-reports/',
	AGM_DOCUMENTS: '/investors/agm-documents/',
	ETHICALEMPLOYER: '/ethical-employer/',
	GENDERPAY: '/gender-pay/',
	BU_CRPS: '/carbon-reduction-plan/',
	INNOTRANS_2024: '/innotrans2024',
	INNOTRANS_OPERATIONAL:
		'/innotrans2024/operational-planning-performance-software',
	INNOTRANS_SAFETY_RISK:
		'/innotrans2024/safety-risk-remote-condition-monitoring-software',
	INNOTRANS_SMART_TICKETING: '/innotrans2024/smart-ticketing-solutions',
	INNOTRANS_COMPUTER_AIDED: '/innotrans2024/computer-aided-dispatch',
};

export const NAVIGATION = [
	{
		label: 'Our Solutions',
		globalNavigation: GLOBAL_NAVIGATION,
	},
	{
		to: LINKS.ABOUT_TRACSIS,
		label: 'About Tracsis',
	},
	{
		to: LINKS.CAREERS,
		label: 'Careers',
		description:
			'Tracsis is a fast growing, successful company which offers an exciting and dynamic working environment and a great team.',
		links: [{ to: LINKS.CAREERS, label: 'Unlock your potential' }],
		subMenu: [
			{
				label: 'Life at Tracsis',
				to: LINKS.LIFE_AT_TRACSIS,
				description:
					'A snapshot of our culture, history, and commitment to be a business for positive impact.',
			},
			{
				label: 'Empowering our team to make it happen',
				to: LINKS.EMPOWERING_OUR_TEAM,
				description:
					'How we create an exciting and dynamic working environment.',
			},
			{
				label: 'View our career opportunities',
				to: LINKS.VACANCIES,
				description: 'All of our open positions.',
			},
			{
				label: 'Join the right team',
				to: LINKS.JOIN_THE_RIGHT_TEAM,
				description: 'Multiple divisions, multiple careers paths, one Tracsis.',
			},
		],
	},
	{
		to: LINKS.INVESTORS,
		label: 'Investors',
		description: '',
		links: [{ to: LINKS.INVESTORS, label: 'View the Investors page' }],
		subMenu: [
			{
				label: 'Investment case',
				to: LINKS.INVESTMENT_CASE,
			},
			{
				label: 'Board of Directors',
				to: LINKS.BOARD_DIRECTORS,
			},
			{
				label: 'Share price information',
				to: LINKS.SHARE_PRICE,
			},
			{
				label: 'Reports & presentations',
				to: LINKS.REPORTS_PRESENTATIONS,
			},
			{
				label: 'Documents',
				to: LINKS.DOCUMENTS,
			},
			{
				label: 'Significant Shareholders',
				to: LINKS.SIGNIFICANT_SHAREHOLDERS,
			},
			{
				label: 'Advisors',
				to: LINKS.ADVISORS,
			},
			{
				label: 'Corporate Governance',
				to: LINKS.CORPORATE_GOVERNANCE,
			},
			{
				label: 'AIM Rule 26',
				to: LINKS.AIM_26,
			},
			{
				label: 'Investor day demonstrations',
				to: LINKS.INVESTORS_RAIL_TECH,
			},
			{
				label: 'Regulatory News',
				to: LINKS.REGULATORY_NEWS,
			},
		],
	},
	{
		to: LINKS.PRESS,
		label: 'Press & Media',
		description: 'The latest news, case studies and resources from Tracsis.',
		links: [{ to: LINKS.PRESS, label: 'View the Press & Media page' }],
		subMenu: [
			{
				label: 'News',
				to: LINKS.NEWS,
			},
			{
				label: 'Case studies',
				to: LINKS.CASE_STUDIES,
			},
			{
				label: 'Resources',
				to: LINKS.RESOURCES,
			},
			{
				label: 'Media Assets',
				to: LINKS.MEDIA_ASSETS,
			},
		],
	},
	{
		to: LINKS.CONTACT,
		label: 'Contact',
	},
];

export const SUB_NAVIGATION = [
	{
		to: LINKS.TERMS,
		label: 'Terms and conditions',
	},
	{
		to: LINKS.PRVIACY,
		label: 'Privacy notice',
	},
	{
		to: LINKS.COOKIES,
		label: 'Cookie policy',
	},
	{
		to: LINKS.ETHICAL_EMPLOYER,
		label: 'Modern day slavery policy',
	},
	{
		to: LINKS.GENDER_PAY,
		label: 'Gender pay gap reporting',
	},
	{
		to: LINKS.CARBON_REDUCTION,
		label: 'PPN06 Carbon Reduction Plans',
	},
];

export const INNOTRANS_2024_NAV = [
	{
		to: LINKS.INNOTRANS_2024,
		label: 'INNOTRANS 24',
		description: 'Tracsis Rail Technology and Services',
		links: [{ to: `${LINKS.INNOTRANS_2024}#hub-contact`, label: 'Contact Us' }],
		subMenu: [
			{
				label: 'Operational Planning and Performance Software',
				to: LINKS.INNOTRANS_OPERATIONAL,
				description:
					'Cutting-edge tools designed to elevate railway operations',
			},
			{
				label: 'Safety, Risk, and Remote Condition Monitoring Software',
				to: LINKS.INNOTRANS_SAFETY_RISK,
				description:
					'Innovative tools for managing safety, mitigating risks, and predictive maintenance in rail transport',
			},
			{
				label: 'Smart Ticketing Solutions',
				to: LINKS.INNOTRANS_SMART_TICKETING,
				description:
					'PAYG / ABT, Multi-token travel and Automated Delay repay for an improved customer experience',
			},
			{
				label: 'Computer Aided Dispatch',
				to: LINKS.INNOTRANS_COMPUTER_AIDED,
				description: 'Technology that eliminates the risk of human error',
			},
		],
	},
];

export const FOOTER_NAV_1 = [
	{
		label: 'Our Solutions',
		header: true,
	},
	{
		label: DIVISIONS.RAIL.label,
		to: DIVISIONS.RAIL.to,
	},
	{
		label: DIVISIONS.DACE.label,
		to: DIVISIONS.DACE.to,
	},
	{
		to: LINKS.ABOUT_TRACSIS,
		label: 'About Tracsis',
		header: true,
	},
	{
		to: LINKS.SUSTAINABILITY,
		label: 'Sustainability',
	},
	{
		to: LINKS.ACQUISITIONS,
		label: 'Acquisitions',
	},
	{
		to: LINKS.HISTORY,
		label: 'Our History',
	},
];

export const FOOTER_NAV_2 = [
	{
		label: 'Investors',
		to: LINKS.INVESTORS,
		header: true,
	},
	{
		label: 'Investment case',
		to: LINKS.INVESTMENT_CASE,
	},
	{
		label: 'Board of Directors',
		to: LINKS.BOARD_DIRECTORS,
	},
	{
		label: 'Share price information',
		to: LINKS.SHARE_PRICE,
	},
	{
		label: 'Reports & presentations',
		to: LINKS.REPORTS_PRESENTATIONS,
	},
	{
		label: 'Documents',
		to: LINKS.DOCUMENTS,
	},
	{
		label: 'Significant Shareholders',
		to: LINKS.SIGNIFICANT_SHAREHOLDERS,
	},
	{
		label: 'Advisors',
		to: LINKS.ADVISORS,
	},
	{
		label: 'Corporate Governance',
		to: LINKS.CORPORATE_GOVERNANCE,
	},
	{
		label: 'AIM Rule 26',
		to: LINKS.AIM_26,
	},
	{
		label: 'Investor day demonstrations',
		to: LINKS.INVESTORS_RAIL_TECH,
	},
	{
		label: 'Regulatory News',
		to: LINKS.REGULATORY_NEWS,
	},
];

export const FOOTER_NAV_3 = [
	{
		label: 'Press & Media',
		to: LINKS.PRESS,
		header: true,
	},
	{
		label: 'Tracsis Media Assets',
		to: LINKS.MEDIA_ASSETS,
	},
	{
		label: 'News',
		to: LINKS.NEWS,
	},
	{
		label: 'Resources',
		to: LINKS.RESOURCES,
	},
	{
		label: 'Case Studies',
		to: LINKS.CASE_STUDIES,
	},
];

export const FOOTER_NAV_4 = [
	{
		to: LINKS.CAREERS,
		label: 'Careers',
		header: true,
	},
	{
		label: 'Life At Tracsis',
		to: LINKS.LIFE_AT_TRACSIS,
	},
	{
		label: 'Empowering Our Team To Make It Happen',
		to: LINKS.EMPOWERING_OUR_TEAM,
	},
	{
		label: 'View Our Career Opportunities',
		to: LINKS.VACANCIES,
	},
	{
		label: 'Join The Right Team',
		to: LINKS.JOIN_THE_RIGHT_TEAM,
	},
];

export const SOCIAL = [
	{
		to: 'https://www.linkedin.com/company/tracis-plc/',
		platform: 'LinkedIn',
	},
];

export const INVESTORS_SUBNAV = [
	{
		to: LINKS.INVESTORS,
		label: 'Investors home',
	},
	{
		to: LINKS.SHARE_PRICE,
		label: 'Share price information',
	},
	{
		to: LINKS.BOARD_DIRECTORS,
		label: 'Board of Directors',
	},
	{
		to: LINKS.REPORTS_PRESENTATIONS,
		label: 'Reports & presentations',
	},
	{
		to: LINKS.REGULATORY_NEWS,
		label: 'Regulatory news',
	},
	{
		to: LINKS.DOCUMENTS,
		label: 'Documents',
	},
	{
		to: LINKS.CORPORATE_GOVERNANCE,
		label: 'Corporate Governance',
	},
	{
		to: LINKS.INVESTMENT_CASE,
		label: 'Investment case',
	},
	{
		to: LINKS.ADVISORS,
		label: 'Advisors',
	},
	{
		to: LINKS.SIGNIFICANT_SHAREHOLDERS,
		label: 'Significant Shareholders',
	},
	{
		to: LINKS.INVESTORS_RAIL_TECH,
		label: 'Investor day demonstrations',
	},
	{
		to: LINKS.AIM_26,
		label: 'AIM Rule 26',
	},
];

export const PRIVACY_POLICY = [
	{
		to: '/priacy-policy#definitions',
		label: '1. Definitions and Interpretation',
		id: 'definitions',
	},
	{
		to: '/priacy-policy#about',
		label: '2. Information About Us',
		id: 'about',
	},
	{
		to: '/priacy-policy#cover',
		label: '3. What Does This Notice Cover?',
		id: 'cover',
	},
	{
		to: '/priacy-policy#personal-data',
		label: '4. What Is Personal Data?',
		id: 'personal-data',
	},
	{
		to: '/priacy-policy#rights',
		label: '5. What Are Your Rights?',
		id: 'rights',
	},
	{
		to: '/priacy-policy#data-collection',
		label: '6. What Data Do We Collect and How?',
		id: 'data-collection',
	},
	{
		to: '/priacy-policy#use-personal-data',
		label: '7. How Do We Use Your Personal Data?',
		id: 'use-personal-data',
	},
	{
		to: '/priacy-policy#keep-personal-data',
		label: '8. How Long Do We Keep Your Personal Data?',
		id: 'keep-personal-data',
	},
	{
		to: '/priacy-policy#store-personal-data',
		label: '9. How and Where Do We Store or Transfer Your Personal Data?',
		id: 'store-personal-data',
	},
	{
		to: '/priacy-policy#share-personal-data',
		label: '10. Do We Share Your Personal Data?',
		id: 'share-personal-data',
	},
	{
		to: '/priacy-policy#control-personal-data',
		label: '11. How Can You Control Your Personal Data?',
		id: 'control-personal-data',
	},
	{
		to: '/priacy-policy#withhold-information',
		label: '12. Can You Withhold Information?',
		id: 'withhold-information',
	},
	{
		to: '/priacy-policy#access-personal-data',
		label: '13. How Can You Access Your Personal Data?',
		id: 'access-personal-data',
	},
	{
		to: '/priacy-policy#use-cookies',
		label: '14. How Do We Use Cookies?',
		id: 'use-cookies',
	},
	{
		to: '/priacy-policy#contact-us',
		label: '15. How Do You Contact Us?',
		id: 'contact-us',
	},
	{
		to: '/priacy-policy#changes-to-notice',
		label: '16. Changes to this Privacy Notice',
		id: 'changes-to-notice',
	},
];

export const COOKIE_POLICY = [
	{
		to: '/cookie-policy#what-cookies',
		label: 'What are cookies?',
		id: 'what-cookies',
	},
	{
		to: '/cookie-policy#how-cookies',
		label: 'How do we use cookies?',
		id: 'how-cookies',
	},
	{
		to: '/cookie-policy#types-cookies',
		label: 'Types of Cookies we use',
		id: 'types-cookies',
	},
	{
		to: '/cookie-policy#data',
		label: 'How we use your data?',
		id: 'data',
	},
	{
		to: '/cookie-policy#embed-content',
		label: 'Embedded content from other websites',
		id: 'embed-content',
	},
	{
		to: '/cookie-policy#analytics',
		label: 'Analytics',
		id: 'analytics',
	},
	{
		to: '/cookie-policy#more-information',
		label: 'More Information',
		id: 'more-information',
	},
];
